<template>
  <div class="dialog-overlay" v-if="visible">
    <div class="dialog" :style="{ width: computedWidth }">
      <div class="dialog-header">
        <span class="dialog-title" v-if="showTitle">{{ title }}</span>
        <!-- 关闭弹窗x图标 -->
        <i class="el-icon-close" @click.stop="closeDialog" v-if="showCloseIcon"></i>
        <!-- logo图标 -->
        <slot name="tb"> </slot>
        <!-- 领券图标 -->
        <img src="../../assets/images/newDialogLine.png" alt="" v-if="showLine" />
        <!-- 横线图片 -->
        <img src="../../assets/images/newDialogLine.png" alt="" v-if="showLine" />
      </div>
      <div class="dialog-content">
        <slot></slot>
      </div>
      <div class="dialog-footer">
        <div class="button-container">
          <div class="button cancel" id="cancelButton" @click.stop="closeDialog" v-if="showCancelBtn">{{cancelText}}</div>
          <div class="button confirm" id="confirmButton" @click.stop="confirm" v-if="showConfirmBtn" v-preventReClick>{{confirmText}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'newDialog',
  props: {
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: true
    },
    showCancelBtn: {
      type: Boolean,
      default: true
    },
    showConfirmBtn: {
      type: Boolean,
      default: true
    },
    showCloseIcon: {
      type: Boolean,
      default: true
    },
    computedWidth: {
      type: String,
      default: '500px'
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    showLine: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确定'
    },
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog {
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url('../../assets/images/newDialogBackgroun.jpg');
  background-size: contain;
  background-repeat: repeat-x;
  min-height: 300px;
}

.dialog-header {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 120px;
  width: 100%;
  position: relative;
  i {
    position: absolute;
    top: 0px;
    right: 5px;
    font-size: 25px;
    cursor: pointer;
    color: #2f6df9;
  }
  img:nth-of-type(1) {
    position: absolute;
    bottom: 45px;
  }
  img:nth-of-type(2) {
    position: absolute;
    bottom: 10px;
    left: 13px;
  }
  img:nth-of-type(3) {
    position: absolute;
    transform: rotate(180deg);
    bottom: 10px;
    right: 13px;
  }
}

.dialog-title {
  font-size: 20px;
  color: #2f6df9;
  font-weight: bold;
}

.dialog-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  flex-grow: 1; /* 中间部分自适应高度 */
  margin: 20px 0px;
}

.dialog-footer {
  height: 100px;
  width: 100%;
  flex: 0.5;
}

.button-container {
  display: flex;
  justify-content: center;
  margin: 10px 0;
}

.button {
  padding: 8px 30px;
  cursor: pointer;
  border: 1px solid #2f6df9;
  border-radius: 50px;
  text-align: center;
  width: 120px;
  margin: 0 10px;
  box-shadow: 0 1px 5px #2f6df9; /* 添加阴影效果 */
  transition: box-shadow 0.3s ease; /* 添加过渡效果 */
}

.button:hover {
  box-shadow: 0 1px 10px #2f6df9; /* 鼠标悬停时的阴影效果 */
}

.cancel {
  color: #2f6df9;
  background-color: rgb(255, 255, 255);
}

.confirm {
  background-color: #2f6df9;
  color: #ffff;
}
</style>
